import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NzFloatButtonModule } from 'ng-zorro-antd/float-button';

/**
 * Botón "volver arriba".
 *
 * Envuelve `nz-float-button-top`, que es el sustituto que ng-zorro ofrece para `nz-back-top`
 * tras eliminarlo en la versión 21 (el subpaquete `ng-zorro-antd/back-top` ya no existe).
 *
 * El envoltorio existe para que el marcado de ng-zorro no viva en las plantillas de feature
 * —igual que `app-card` y el resto de los widgets— y porque esto estaba repetido idéntico en
 * cuatro plantillas: form-layout, product-detail, biometrics y pre-affiliation.
 *
 * Sobre el aspecto: se adopta el de ng-zorro (`nzShape="square"` es el más cercano al botón
 * anterior) y solo se conserva el ícono propio, que `nzIcon` admite como plantilla porque lo
 * resuelve con `*nzStringTemplateOutlet`. No se replica el `.scroll-top` anterior —fondo #eef0f4,
 * 4,28rem, posición fija propia— porque exigiría anular con `::ng-deep` el posicionamiento, la
 * forma y los colores que el componente ya trae; el aspecto cambia respecto a Angular 20 y eso
 * es deliberado.
 *
 * El comportamiento (aparecer pasado el umbral, volver al tope al pulsar) lo aporta ng-zorro:
 * lee el desplazamiento con `NzScrollService` y escucha `scroll` con debounce de 50 ms.
 */
@Component({
  standalone: true,
  selector: 'app-back-to-top',
  imports: [NzFloatButtonModule],
  template: `
    <nz-float-button-top [nzVisibilityHeight]="visibilityHeight()" [nzIcon]="icono" nzShape="square" />
    <ng-template #icono>
      <i class="icmn-arrow-up"></i>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppBackToTopComponent {
  /**
   * Desplazamiento en píxeles a partir del cual aparece el botón.
   *
   * Se mantiene el 100 que traían las cuatro plantillas con `nz-back-top`; el valor por omisión
   * de `nz-float-button-top` es 400.
   */
  visibilityHeight = input<number>(100);
}
